import * as React from "react";
import { SizedTextDataInput } from "../../textDataInput/TextDataInput";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { IMembersPortalField } from "../../../../membersportal/types/IMembersPortalField";
import { DONOTCARE_ABOUTWORKFLOWS, EMPTY_STRING_VALUE, HASOPEN_WORKFLOWS, INTRAY, PRODUCT_WORK_SOURCE_STATE_KEY, REPERTOIRE, SEARCH_VIEW_HAS_OPEN_WORKFLOW, WITHOUTOPEN_WORKFLOWS, ADD_TO_PACKAGE_ACTION, SEARCH_VIEW_WORKS } from "../../../Consts"; import DisplayTableSearchResults from "../../../../membersportal/sharedComponents/displayTableSearchResults/DisplayTableSearchResults";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import { ComponentsHelper } from "../../../../core/services/ComponentHelper";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";
import ActionButton from "../../actionButton/ActionButton";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { IWorksSearchQuery } from "../../../types/IWorksSearchQuery";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { useMsal } from "@azure/msal-react";
import { SizedRadiobuttonDataInput } from "../../radioButtonDataInput/RadiobuttonDataInput";
import SelectorView from "../../selectorView/SelectorView";
import { addWorkToProduct } from "../../../../redux/reducers/RepertoireReducer";
import { MessageBanner, MessageType } from "../../messageBanner/MessageBanner";
import { CLOSE_SVG } from "../../../IconConsts";

export interface ProductWorkSearchModalViewProps {
    searchWorks: (query: IWorksSearchQuery, modalOpen: boolean) => void;
    searchViewData: IRepertoireComponentDataItem;
    searchResultsTableData: IRepertoireComponentDataItem;
    worksSearchResults: any;
    searchSuccessful: boolean;
    isDataSourceIntray: boolean;
    paymentStatementGeneralDataViewData?: IMembersPortalComponentDataItem;
    lookupValues: ILookupDictionary;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    currentPage?: number;
    resetPagination: (repertoireSection: string) => void;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    currentUserNameNumber?: string;
    modalTitle: string;
    hideModal: () => void;
    handleAddNewWork: () => void;
    addWorkToProduct?: typeof addWorkToProduct;
    saveResultData?: IRepertoireComponentDataItem;
}
const ProductWorkSearchModalView: React.FC<ProductWorkSearchModalViewProps> = ({
    searchWorks,
    searchViewData,
    searchSuccessful,
    searchResultsTableData,
    worksSearchResults,
    isDataSourceIntray,
    indexOfFirstResult,
    indexOfLastResult,
    resultsPerPage,
    currentPage,
    resetPagination,
    updatePagination,
    lookupValues,
    hideModal,
    modalTitle,
    handleAddNewWork,
    addWorkToProduct,
    saveResultData
}) => {
    const [loaded, setLoaded] = React.useState(false);
    const [invalidWorkStatuses, setInvalidWorkStatuses] = React.useState<string[]>([]);
    const [errorMessages, setErrorMessages] = React.useState<string[]>([]);
    const [filteredFields, setFilteredFields] = React.useState<IRepertoireField[] | IMembersPortalField[]>([]);
    const [filteredSearchResults, setFilteredSearchResults] = React.useState<IRepertoireField[]>([]);
    const { instance, accounts } = useMsal();

    const [formData, setFormData] = React.useState({
        title: '',
        number: '',
        artist: '',
        writers: '',
        workType: '',
        societyAccountNumber: '',
        dataSource: REPERTOIRE,
        hasOpenWorkflow: DONOTCARE_ABOUTWORKFLOWS,
        workBatchID: undefined,
        workGroupID: undefined,
        });

    React.useEffect(() => {
        setLoaded(true);
        const account = accounts[0]
        ComponentsHelper.createBearerHeaderFromAADLogin(instance, account);
        resetPagination('works');
    }, [])

    React.useEffect(() => {

        if (searchViewData && searchViewData.fields) {
            let filteredSearchFields = searchViewData.fields.filter(
                (searchField: IRepertoireField | IMembersPortalField) =>
                    searchField.componentInstance === 'works' && searchField.name !== ADD_TO_PACKAGE_ACTION
            );

            setFilteredFields(filteredSearchFields);
        }

        if (searchResultsTableData.fields) {
            let filteredFields = searchResultsTableData.fields.filter(
                (field: IRepertoireField) =>
                    field.componentInstance === 'works' && field.name !== ADD_TO_PACKAGE_ACTION
        
            );
            setFilteredSearchResults(filteredFields);
        }

        if (lookupValues && lookupValues['WorkStatus']) {
            let invalidWorkStatusCodes = lookupValues['WorkStatus'].lookups
                .filter((lookup: any) => lookup.extraFields && lookup.extraFields.PreventOnProduct)
                .map((lookup: any) => lookup.code);

            setInvalidWorkStatuses(invalidWorkStatusCodes);
        }

    }, [searchViewData])

    const updateUserPagination = (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => {
        updatePagination(indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage, repertoireSection);
    }

    const changeData = (value: any, fieldName: IRepertoireStateKeys) => {
        setFormData(
            {...formData, [fieldName]: value}
        )
     }

    const  keyDownSubmit = (value: any) => {
        if (value.key === 'Enter') {
            onClickSearch();
        }
    }

    const onClickSearch = () => {
        setErrorMessages([]);

        let hasOpenWorkFlowBoolean = null;
        if (formData.hasOpenWorkflow === HASOPEN_WORKFLOWS) {
            hasOpenWorkFlowBoolean = true;
        }
        if (formData.hasOpenWorkflow === WITHOUTOPEN_WORKFLOWS) {
            hasOpenWorkFlowBoolean = false;
        }
        let searchQuery = {
            title: formData.title,
            number: formData.number,
            artist: formData.artist,
            writers: formData.writers,
            workType: formData.workType,
            societyAccountNumber: formData.societyAccountNumber,
            dataSource: formData.dataSource,
            workBatchID: formData.workBatchID,     
            hasOpenWorkflow: hasOpenWorkFlowBoolean,
            workGroupID: formData.workGroupID,
            includeIsReplacedWorks: formData.dataSource == REPERTOIRE ? true : false
        };

        searchWorks(searchQuery, true);
    };

    const handleHasOpenWorkFlowChange = (value: string) => {
        setFormData(
            {...formData, hasOpenWorkflow: value}
        )
    }

    const handleDataSourceChange = (value: any) => {
        setFormData(
            {...formData, dataSource: value}
        )
    }

    const rowActions = {
        textButton: {
            text: 'Select',
            onClick: (work) => {
                if (work.workTerritorySpecificInfo && work.workTerritorySpecificInfo.length > 0)
                {
                    for (let i = 0; i < work.workTerritorySpecificInfo.length; i++) {
                        if (invalidWorkStatuses.includes(work.workTerritorySpecificInfo[i].workStatus)) {
                            setErrorMessages([saveResultData.fields.find(x => x.name.toString() === 'addWorkToProductWithStatusNotAllowed').data]);
                            return;
                        }
                    }
                }
                addWorkToProduct(work);
            }
        }
    }

    const renderSearchFields = () => {
            let filteredSearchFieldsMapper = (searchField: IRepertoireField | IMembersPortalField, index: number): React.ReactElement => {
                let formField: React.ReactElement = <></>;

                if ((searchField.fieldType === 'text' || searchField.fieldType === 'integer' || searchField.fieldType === 'decimal')) {
                    formField =
                        <div key={index}>
                            <SizedTextDataInput
                                fieldType={searchField.fieldType}
                                useEnterSubmit={true}
                                label={searchField.data}
                                fieldName={searchField.name}
                                changeData={(value, fieldName) => changeData(value, fieldName)}
                                handleKeyDown={keyDownSubmit}
                                value={searchField.name === 'values' ? EMPTY_STRING_VALUE : formData[searchField.name]}
                                isHidden={false}
                            />
                        </div>
                }

                if (searchField.name === PRODUCT_WORK_SOURCE_STATE_KEY && isDataSourceIntray)
                        formField =
                            <div key={index}>
                                <SelectorView
                                    selection={formData.dataSource}
                                    setSelection={handleDataSourceChange}
                                    option1={REPERTOIRE}
                                    option1Label={REPERTOIRE}
                                    option2={INTRAY} 
                                    option2Label={INTRAY}
                                    selectorTitle={searchField.data}
                                />
                            </div>

                if (searchField.fieldType === 'boolean' && searchField.name === SEARCH_VIEW_HAS_OPEN_WORKFLOW) {

                    formField =  <div key={index}>
                                    <SizedRadiobuttonDataInput
                                        selectedValue={formData.hasOpenWorkflow}
                                        onSelectionChange={handleHasOpenWorkFlowChange}
                                        radioName="hasOpenWorkFlow"
                                        title={searchField.data}
                                        options={[
                                            { desc: ComponentsHelper.getFieldValueByName("doNotCareAboutWorkflowsDesc", searchViewData.fields), code: DONOTCARE_ABOUTWORKFLOWS },
                                            { desc: ComponentsHelper.getFieldValueByName("hasOpenWorkflowsDesc", searchViewData.fields), code: HASOPEN_WORKFLOWS },
                                            { desc: ComponentsHelper.getFieldValueByName("withoutOpenWorkflowsDesc", searchViewData.fields), code: WITHOUTOPEN_WORKFLOWS }
                                        ]}
                                    />
                                </div>
                }

                return formField;

            };
            return filteredFields.map(filteredSearchFieldsMapper);
    };

    if (loaded && filteredFields && filteredFields.length > 0) {
        return (
            <div className="repertoireModal">
                <div className={"modal modal--large"}>
                    <div className='modal-header' style={{
                        background: "#38429C",
                        color: "white",
                        }}>
                        <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={() => hideModal()}>
                            <i className="icon ms-Icon ms-Icon--ChromeClose" style={{ color: "white" }} title="Close"></i>
                        </button>
                        <h1 className="modal-title">{modalTitle}</h1>
                    </div>
                    <div className="fixedPart" />
                    <div className="dynamicPart">
                            <div className="modalBody">
                                <div className="searchView">
                                    <div key='searchFields' className="row">
                                        {renderSearchFields()}
                                    </div>
                                    <div key='action' className="row">
                                        <div className="doneButtonRow">
                                            <ActionButton buttonText="Search" buttonAction={onClickSearch}/>
                                        </div>
                                    </div>
                                    {searchSuccessful && <div key='results'>
                                    <DisplayTableSearchResults
                                        searchSuccessful={searchSuccessful}
                                        searchResultsTableData={filteredSearchResults}
                                        searchResults={worksSearchResults}
                                        indexOfFirstResult={indexOfFirstResult}
                                        indexOfLastResult={indexOfLastResult}
                                        resultsPerPage={resultsPerPage}
                                        currentPage={currentPage}
                                        updatePagination={updateUserPagination}
                                        lookupValues={lookupValues}
                                        resetPagination={resetPagination}
                                        rowActions={rowActions}
                                        repertoireSection={SEARCH_VIEW_WORKS}
                                    />
                                    </div>}
                                </div>
                            </div>
                        </div>
                        {errorMessages && errorMessages.length > 0 &&
                            <MessageBanner
                                resetMessageBanner={() => setErrorMessages([])} 
                                messageType={MessageType.Danger} 
                                messages={errorMessages} 
                            />}
                        {searchSuccessful &&
                            <div key='action' className="doneButtonRow">
                                <div className="doneButton">
                                    <ActionButton buttonText="Done" buttonAction={() => hideModal()} />
                                </div>
                            </div>}
                </div>
            </div>
        );
    }
    return <div>Loading ...</div>
}

export default ProductWorkSearchModalView;